import * as React from "react";
import { HooplaPurchase } from "types";
import * as styles from "./styles";
import { FormattedMessage } from "react-intl";
import Typography from "components/Typography";
import prettydate, { formatTime } from "../../helpers/prettydate";
import IconVenue from "assets/icons/icon_venue";
import IconDate from "assets/icons/icon_date";
import { RouteComponentProps, withRouter } from "react-router";
import InfoBubble from "components/InfoBubble";
import TicketDate from "components/TicketDate";
import TicketImage from "components/TicketImage";
import IconCalendar from "../../assets/icons/calendar";
import { connect } from "react-redux";
import { ApplicationState } from "../../stores";
import PurchaseTableNarrow from "../PurchaseTableNarrow";
import PurchaseTable from "../PurchaseTable";

interface IProps {
  locale: string;
  purchase: HooplaPurchase;
}

const TicketCard: React.FunctionComponent<IProps & RouteComponentProps> = (props) => {
  const [width, setWidth] = React.useState(0);
  React.useLayoutEffect(() => {
    function updateSize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const { purchase } = props;
  return (
    <React.Fragment>
      <div className={styles.ticketWrapper} key={purchase.event.eventId}>
        <div className={styles.ticket}>
          {purchase.event.data.image || purchase.event.images ? (
            <TicketImage
              image={purchase.event.data.image}
              images={purchase.event.images}
              image_crop={purchase.event.data.image_crop}
              alt={purchase.event.name}
            />
          ) : (
            <TicketDate event={purchase.event} />
          )}
          <div className={styles.middle}>
            <div className={styles.info}>
              <div className={styles.headerBox}>
                <Typography type={"headline"} color={"black"}>
                  {purchase.event.name} (
                  <FormattedMessage
                    id="components.TicketList.numTicketsEvent"
                    values={{
                      tickets: purchase.purchases.reduce(
                        (acc, purchase) => acc + purchase.numberOfTickets,
                        0,
                      ),
                    }}
                  />
                  )
                </Typography>
                <a
                  className={styles.addToCalendar}
                  href={`/api/v2.0/public/events/${purchase.event.eventId}/calendar.ics`}
                >
                  <FormattedMessage
                    id="components.TicketList.addToCalendar"
                    defaultMessage="Add to calendar"
                  />
                </a>
              </div>
              <div className={styles.eventInfoDiv}>
                {purchase.event.data.location["name"] && (
                  <InfoBubble content={purchase.event.data.location["name"]} icon={<IconVenue />} />
                )}
                {(!purchase.event.dateFormat ||
                  purchase.event.dateFormat.dateType !== "dont_show") && (
                  <InfoBubble
                    content={
                      <span>
                        {prettydate(
                          new Date(purchase.event.start),
                          new Date(purchase.event.end),
                          props.locale,
                          purchase.event.dateFormat,
                        )}
                      </span>
                    }
                    icon={<IconCalendar />}
                  />
                )}
                {(!purchase.event.dateFormat ||
                  purchase.event.dateFormat?.dateType === "start_date_and_time" ||
                  purchase.event.dateFormat?.dateType === "start_end_date_and_time") && (
                  <InfoBubble
                    content={formatTime(new Date(purchase.event.start))}
                    icon={<IconDate />}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <table className={styles.purchasesTable}>
          <thead>
            <tr>
              <th />
              <th>
                <FormattedMessage id="components.TicketList.purchaseDate" />
              </th>
              <th>
                <FormattedMessage id="components.TicketList.orderId" />
              </th>
              <th>
                <FormattedMessage id="components.TicketList.count" />
              </th>
              <th />
            </tr>
          </thead>
          {width < 800 ? (
            <PurchaseTableNarrow
              purchases={purchase.purchases.sort((a, b) =>
                a.purchase.finalized > b.purchase.finalized ? -1 : 1,
              )}
              eventId={purchase.event.eventId}
            />
          ) : (
            <PurchaseTable
              purchases={purchase.purchases.sort((a, b) =>
                a.purchase.finalized > b.purchase.finalized ? -1 : 1,
              )}
              eventId={purchase.event.eventId}
            />
          )}
        </table>
      </div>
    </React.Fragment>
  );
};

export default connect((state: ApplicationState) => ({
  locale: state.i18n.locale,
}))(withRouter(TicketCard));
